export default __webpack_public_path__ + "static/media/(70).b95e7f88.jpg";